/* eslint-disable no-unused-vars */
import { Box } from '@chakra-ui/react';

export default function About() {
  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      width={'100%'}
    >
      This is About Page. Please comme back to see new contents 😉😉
    </Box>
  );
}
